<!--
 * @Author: your name
 * @Date: 2021-08-03 15:16:37
 * @LastEditTime: 2022-06-09 11:42:33
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\stock-structure\structure.vue
-->
<template>
  <BjGraph
    v-if="refresh"
    :left-addon="hasPermissionBtn"
    :menu="hasPermissionBtn"
    :api="api"
    :movable="hasPermissionBtn"
    @refresh="refreshData"
  />
</template>
<script>
import { stockApi } from '@/api';
import BjGraph from '@/components/BjGraph';
export default {
  name: 'SettingStockStructureView',
  components: {
    BjGraph,
  },
  data() {
    return {
      api: stockApi.getWarehouseStructuresDetail,
      refresh: true,
    };
  },
  computed: {
    // 是否有配置权限
    hasPermissionBtn() {
      return this.$store.getters.userPermissionBtns.includes(
        'SettingStockStructureIndex_Set'.toLocaleLowerCase(),
      );
    },
  },
  created() {},
  mounted() {},
  methods: {
    refreshData() {
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
  },
};
</script>
